import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { routes } from 'app/constants';
import { MrLoading } from '@ion/components';
import { useUserContext } from '@ion/user';
import useLazyQueryUserOrganizations from '@ion/api/auth0/useLazyQueryUserOrganizations';
import OrgSwitcher from 'app/components/org-switcher';

export default function LoginInterstitial() {
  const { currentOrg } = useUserContext();
  const [dismissed, setDismissed] = useState(false);
  const [getUserOrganizations, { data: orgs, done: orgQueryDone }] = useLazyQueryUserOrganizations();

  useEffect(() => {
    getUserOrganizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!orgQueryDone) {
    return <MrLoading />;
  }

  const showOrgSwitcher = orgs.length > 1 && !dismissed;

  if (showOrgSwitcher) {
    return <OrgSwitcher orgId={currentOrg.id} closeModal={() => setDismissed(true)} />;
  }

  return <Redirect to={routes.home} />;
}
